import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const removeInitialLoader = () => {
  const loader = document.getElementById('initial-loader');
  if (!loader) return;
  loader.classList.add('fade-out');
  setTimeout(() => {
    loader.remove();
  }, 400);
};

removeInitialLoader();

// MINIMAL SERVICE WORKER - Only for PWA installation, no caching
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW: Minimal service worker registered for PWA');
      })
      .catch((error) => {
        console.log('SW: Registration failed (PWA install may not work):', error);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
